<template>
  <div>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <h1 style="padding: 10px 15px 0">Изменение баланса</h1>

        <div style="padding: 0 10px 10px">
          <v-tabs>
            <v-tabs-slider color="accent" />

            <v-tab
              v-for="title in tabTitles"
              :key="title"
            >
              {{ title }}
            </v-tab>

            <v-tab-item style="padding: 30px 10px 0">
              <v-text-field
                v-model="balanceInput"
                outline
                label="Баланс"
                class="field"
                color="accent"
                style="width: 100%"
                @input="updateBalance"
              />

              <v-card-actions>
                <v-spacer />
                <v-btn
                  flat
                  @click="confirmBalance"
                >
                  Подтвердить
                </v-btn>
              </v-card-actions>
            </v-tab-item>

            <v-tab-item style="padding: 30px 10px 0">
              <v-text-field
                :value="balance"
                outline
                readonly
                label="Баланс"
                class="field"
                color="accent"
                style="width: 100%"
              />
              <v-spacer />

              <div style="display: flex; gap: 30px">
                <v-select
                  v-model="select"
                  :items="selectItems"
                  label="Значение"
                  color="accent"
                  outline
                />

                <v-text-field
                  v-model="sumInput"
                  outline
                  label="Сумма"
                  class="field"
                  color="accent"
                  style="width: 100%"
                  @input="updateSum"
                />
              </div>

              <p>При выборе "+" указанная сумма добавится к балансу.</p>
              <p>При выборе "-" указанная сумма вычтется из баланса.</p>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  flat
                  @click="confirmChanges"
                >
                  Подтвердить
                </v-btn>
              </v-card-actions>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import User from '../../../helpers/user'

export default {
  name: 'BalanceModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    balance: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      dialog: this.value,
      balanceInput: this.balance,
      sumInput: '',
      tabTitles: ['Изменить баланс', 'Добавить/Вычесть'],
      selectItems: [{ text: '+', value: 'up' }, { text: '-', value: 'down' }],
      select: 'up'
    }
  },
  watch: {
    value (newVal) {
      this.dialog = newVal
    },
    dialog (newVal) {
      this.$emit('update:balanceDialog', newVal)
      if (!newVal) this.sumInput = null
    },
    balance (newVal) {
      this.balanceInput = newVal
    }
  },
  methods: {
    confirmBalance () {
      this.dialog = false
      if (!User.hasAdminAccess()) {
        this.$emit('show-error')
        return
      }
      if (this.balanceInput === this.balance) return
      this.$emit('update:balanceChanged', {
        balance: this.balanceInput
      })
    },
    confirmChanges () {
      this.dialog = false
      if (!User.hasAdminAccess()) {
        this.$emit('show-error')
        return
      }
      if (!this.sumInput) return
      this.$emit('update:balanceChanged', {
        amount: this.sumInput,
        direction: this.select
      })
    },
    updateBalance (event) {
      if (event.length)
        if (this.balanceInput.search(/[0-9]{0,8}\.[0-9]{0,2}/) !== -1)
          this.$nextTick(() => {
            this.balanceInput = this.balanceInput.match(/[0-9]{0,8}\.[0-9]{0,2}/)[0]
          })
        else
          this.$nextTick(() => {
            const match = this.balanceInput.match(/\d+/)
            this.balanceInput = match ? match[0] : ''
          })
      else
        this.$nextTick(() => {
          this.balanceInput = parseFloat(0).toFixed(2)
        })

    },
    updateSum (event) {
      if (event.length)
        if (this.sumInput.search(/[0-9]{0,8}\.[0-9]{0,2}/) !== -1)
          this.$nextTick(() => {
            this.sumInput = this.sumInput.match(/[0-9]{0,8}\.[0-9]{0,2}/)[0]
          })
        else
          this.$nextTick(() => {
            const match = this.sumInput.match(/\d+/)
            this.sumInput = match ? match[0] : ''
          })
      else
        this.$nextTick(() => {
          this.sumInput = parseFloat(0).toFixed(2)
        })

    }
  }
}
</script>
